import $ from 'jquery'
import Headroom from 'headroom.js';
import Scroll from '../util/Scroll';
import Nav from '../components/Nav';
import Slider from '../components/Slider';
import ScrollOut from 'scroll-out';
import Map from '../components/Map';
import VideoPopup from '../components/VideoPopup';
import NinjaFormExtension from '../components/NinjaFormExtension';
// import 'alpinejs';

export default {
  // JavaScript to be fired on all pages
  init () {
    this.initHeader()
    $('[data-scroll-top]').on('click', () => {
      const scroll = new Scroll;
      scroll.scrollTo(0)
    })
    $('[data-scroll-to]').on('click', (e) => {
      let $trigger = $(e.currentTarget)
      let $target = $(`#${$trigger.data('scroll-to')}`)
      if (!$target.length) {
        return
      }
      const scroll = new Scroll;
      scroll.scrollTo($target.offset().top)
    })
    $('[data-slider]').each(function () {
      let slider = new Slider($(this))
      slider.initialise()
    })
    // Global scroll helper
    window.__scroller = new Scroll;

    $('[data-control="map"]').each(function () {
      let map = new Map($(this))
      map.initialise()
    })
    this.initVideo()
  },
  // JavaScript to be fired on all pages, after page specific JS is fired
  finalize () {
    ScrollOut({
      targets: '[data-scroll-out]',
      // threshold: 0.4,
      once: true,
      cssProps: {
        viewportY: true,
      },
    })
    ScrollOut({
      targets: '[data-scroll-turning]',
      threshold: 0,
      cssProps: {
        viewportY: true,
      },
    })
    $('[data-video-popup]').each(function () {
      let player = new VideoPopup($(this).get(0))
      player.init()
    })
    if ($('.wpforms-confirmation-container-full').length) {
      $('.js-contact-form-description').remove()
    }
    /** Ninja Form */
    if (window.Marionette) {
      NinjaFormExtension.init(window.Marionette)
    }
    
  },
  // Header/navigation scripts
  initHeader () {
    // Navigation
    Nav.init()
    let headroomOptions = {
      offset: 100,
      // css classes to apply
      classes: {
        // when element is initialised
        initial: 'headroom',
        // when scrolling up
        pinned: 'headroom--pinned translate-y-0',
        // when scrolling down
        unpinned: 'headroom--unpinned -translate-y-full',
        // when above offset
        top: 'headroom--top',
        // when below offset
        notTop: 'headroom--not-top',
        // when at bottom of scroll area
        bottom: 'headroom--bottom',
        // when not at bottom of scroll area
        notBottom: 'headroom--not-bottom',
        // when frozen method has been called
        frozen: 'headroom--frozen',
      },
      // callback when pinned, `this` is headroom object
      onPin: () => {
        Nav.onHeadroomPin()
      },
      // callback when unpinned, `this` is headroom object
      onUnpin: () => {
        Nav.onHeadroomUnpin()
      },
      onTop: () => {
        Nav.onHeadroomUnpin()
      },
    }
   var headroom = new Headroom(document.getElementById('primaryHeader'), headroomOptions);
    headroom.init();
  },
  initVideo() {
    let videoContainers = $('.video-container');
    if(videoContainers.length) {
        videoContainers.each(function() {
           let videoContainer = $(this);
           let iFrame = videoContainer.find('iframe').first();
           let overlay = videoContainer.find('.video-overlay');
            if(iFrame) {
                if(iFrame[0].src.indexOf('vimeo') !== -1) {
                   let player = new Vimeo.Player(iFrame);

                    if(overlay) {
                        overlay.on('click', function(e) {
                            videoContainer.addClass('active');
                            $(this).fadeOut();
                            player.play();
                        });
                    }
                } else if(iFrame[0].src.indexOf('youtube') !== -1) {
                    if(overlay) {
                        overlay.on('click', function(e) {
                            videoContainer.addClass('active');
                            iFrame[0].src += '&autoplay=1';

                            setTimeout(function() {
                                overlay.fadeOut();
                            }, 500);
                        });
                    }
                }
            }
        });
    }
  },

};
